import { restClient } from '@uplift/api';
import { useQuery } from '@tanstack/react-query';


// this will be removed soon, so I've added endpoint call inline
// DONT DO THIS IN OTHER PLACES
export const useTwilioToken = ({ appointmentId }: { appointmentId: string }) => {
  const { data, isLoading } = useQuery({
    queryKey: [ 'twilio', appointmentId ],
    queryFn: () => restClient.request<{ token: string }>('/appointment/twilio/generate/token', {
      method: 'POST',
      data: {
        appointment_id: appointmentId,
      }
    })
  });

  return {
    fetching: isLoading,
    twilioToken: data?.token,
  };
};
